export default __webpack_public_path__ + "static/tick-7860487dc3e741c6b6fdf52a7d972e77.png";